<div class="auth">
  <div class="auth-glow" aria-hidden="true"></div>

  <div class="auth-card">
    <span class="brand">
      <svg class="brand-plane" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M2 13l9-2 4-8 1 0-2 8 7 1 0 1-7 1 2 8-1 0-4-8-9-2 0-1z" fill="currentColor"/>
      </svg>
      <span class="brand-word">iFly<span class="brand-word-accent">Finance</span></span>
    </span>

    <div *ngIf="!isSubmitted">
      <p class="eyebrow">Account recovery</p>
      <h1 class="hero-title">Reset password</h1>
      <p class="hero-sub">Enter your new password below to regain access.</p>

      <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" class="auth-form">
        <mat-form-field appearance="outline" class="ifq-field">
          <mat-label>New Password</mat-label>
          <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            formControlName="newPassword"
            placeholder="Enter your new password"
            autocomplete="new-password"
            required>
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hidePassword = !hidePassword"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hidePassword">
            <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="resetPasswordForm.get('newPassword')?.hasError('required')">
            New password is required
          </mat-error>
          <mat-error *ngIf="resetPasswordForm.get('newPassword')?.hasError('minlength')">
            Password must be at least 8 characters long
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="ifq-field">
          <mat-label>Confirm Password</mat-label>
          <input
            matInput
            [type]="hideConfirmPassword ? 'password' : 'text'"
            formControlName="confirmPassword"
            placeholder="Confirm your new password"
            autocomplete="new-password"
            required>
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hideConfirmPassword = !hideConfirmPassword"
            [attr.aria-label]="'Hide confirm password'"
            [attr.aria-pressed]="hideConfirmPassword">
            <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="resetPasswordForm.get('confirmPassword')?.hasError('required')">
            Confirm password is required
          </mat-error>
        </mat-form-field>

        <!-- Password mismatch error -->
        <div *ngIf="resetPasswordForm.hasError('passwordMismatch') && resetPasswordForm.get('confirmPassword')?.touched"
             class="password-mismatch-error">
          <mat-icon>error</mat-icon>
          <span>{{ getPasswordMismatchError() }}</span>
        </div>

        <button
          type="submit"
          class="cta cta--block"
          [disabled]="resetPasswordForm.invalid || isLoading">
          <mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner>
          <span *ngIf="!isLoading">Reset Password</span>
        </button>

        <div class="action-links">
          <a class="text-link" role="button" tabindex="0"
             (click)="backToLogin()"
             (keydown.enter)="backToLogin()"
             (keydown.space)="$event.preventDefault(); backToLogin()">
            <mat-icon aria-hidden="true">arrow_back</mat-icon>
            Back to Login
          </a>
          <a class="text-link" role="button" tabindex="0"
             (click)="requestNewReset()"
             (keydown.enter)="requestNewReset()"
             (keydown.space)="$event.preventDefault(); requestNewReset()">
            <mat-icon aria-hidden="true">refresh</mat-icon>
            Request New Reset
          </a>
        </div>
      </form>
    </div>

    <div *ngIf="isSubmitted" class="success-container">
      <div class="success-icon">
        <mat-icon>check_circle</mat-icon>
      </div>
      <h3>Password Reset Successful!</h3>
      <p>Your password has been successfully reset.</p>
      <p class="redirect-note">You will be redirected to the login page shortly...</p>

      <div class="success-actions">
        <button
          type="button"
          class="cta cta--block"
          (click)="backToLogin()">
          Go to Login
        </button>
      </div>
    </div>
  </div>
</div>
